import { useEffect, useState } from 'react';
import { Flags, syncIntercom, useFlag } from 'ui';
import { FirebaseAuth, User } from 'services/FirebaseService/auth';

export function useMessengerInit() {
  const [user, setUser] = useState<User | null>(null);
  const intercomEnabled = useFlag(Flags.intercomEnabled);

  useEffect(() => {
    const unsubscribe = FirebaseAuth.subscribeToUser((authUser) => {
      setUser(authUser as User | null);
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    // TODO: Remove when staging tests are done and add PROD validation so we avoid triggering Intercom on tests environments
    if (import.meta.env.VITE_APP_E2E_ENV) {
      return;
    }

    syncIntercom({ user, enabled: intercomEnabled });
  }, [intercomEnabled, user]);
}
